import { ReactComponent as Calendar } from "../../assets/images/calendar.svg";
import { ReactComponent as Comment } from "../../assets/images/comment-user.svg";
import { ReactComponent as Doctori } from "../../assets/images/doctor.svg";
import { ReactComponent as Gym } from "../../assets/images/gym.svg";
import { ReactComponent as Time } from "../../assets/images/time-past (1).svg";
import { ReactComponent as Settings } from "../../assets/images/settings (2).svg";
import {ReactComponent as Lefticon} from "../../assets/images/left-arrow.svg";
import {ReactComponent as UserIcon} from "../../assets/images/userIcon.svg"

import DoctorInfo  from "../../assets/images/doctorInfo.png";

import Layout from "../../layout";
import { Link } from "react-router-dom";


function MyProfile(){
    return(
        <>
        <Layout>
        <div className="containter  align-items-center ">
                
                <div className="profile px-5  text-center bg-lightblue ">
                    <div className="d-flex justify-content-center ">
                    <div className=" p-2 rounded-circle border_shradded">
                    <div className="bg-white p-2 rounded-circle " >
                    <img src={DoctorInfo} className="rounded-circle" height={120} width={120}/>
                    </div>
                    </div>
                    </div>
                    <h4 className="dark-text font-weight-bold">Dr. Kate Brown</h4>
                    <span className="light-text">
                    katebrown@gmail.com
                    </span>
                </div>
                <div className="p-5" id="accordion">
                
                    
                    <div className="card  w-75 mx-auto shadow-lg" style={{border:"none",borderRadius:"17px"}}>
                        <div className="px-4 py-3 d-flex justify-content-between align-items-center" id="headingOne">
                            <Link to={"/myAppointment"}>
                            <div className="myProfileCard" > 

                            <span  className=" btn btn-theme-bg "><Calendar /></span>
                            <h6 className="mb-0 ml-2 text" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                              My Appointments
                             </h6>
                             </div>
                             </Link>

                                    <Lefticon />


                              </div>

                        <div id="collapseOne" className="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                            <div className="card-body">
                                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
                            </div>
                        </div>
                    </div>

                    <div className="card  w-75 mx-auto shadow-lg mt-2" style={{border:"none",borderRadius:"17px"}}>
                        <div className="px-4 py-3 d-flex justify-content-between align-items-center" id="headingOne">
                            <Link to={"/appointSetting"}>
                            <div className="myProfileCard" > 

                            <span  className=" btn btn-theme-bg "><Calendar /></span>
                            <h6 className="mb-0 ml-2 text" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                              Appointments Settings
                             </h6>
                             </div>
                             </Link>

                                    <Lefticon />


                              </div>

                        <div id="collapseOne" className="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                            <div className="card-body">
                                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
                            </div>
                        </div>
                    </div>

                    <div className="card  w-75 mx-auto shadow-lg mt-2" style={{border:"none",borderRadius:"17px"}}>
                        <div className="px-4 py-3 d-flex justify-content-between align-items-center" id="headingOne">
                        <Link to={"/chat"}>
                        <div className="myProfileCard"> 
                            <span  className=" btn btn-theme-bg  "><Comment /> </span>
                            <h6 className="mb-0 ml-2 dark-text font-weight-bold" data-toggle="collapse" data-target="#collapsetwo" aria-expanded="true" aria-controls="collapsetwo">
                                
                            Chat

                            </h6>
                            </div>
                            </Link>
                            <Lefticon />
                        </div>

                        <div id="collapsetwo" className="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                            <div className="card-body">
                                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
                            </div>
                        </div>
                    </div>

                    <div className="card  w-75 mx-auto shadow-lg mt-2" style={{border:"none",borderRadius:"17px"}}>
                        <div className="px-4 py-3 d-flex justify-content-between align-items-center" id="headingOne">
                            <Link to={"/history"}>
                        <div className="myProfileCard"> 

<span  className=" btn btn-theme-bg " > <Gym /></span>
                            <h6 className="mb-0 ml-2 dark-text font-weight-bold" data-toggle="collapse" data-target="#collapsefour" aria-expanded="true" aria-controls="collapsefour">
                            My Assigned Exercises
                                                                                                         </h6>
                                                                             </div>
                                                                                 </Link>
                            <Lefticon />
                        </div>

                        <div id="collapsefour" className="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                            <div className="card-body">
                                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
                            </div>
                        </div>
                    </div>
                    <div className="card  w-75 mx-auto shadow-lg mt-2" style={{border:"none",borderRadius:"17px"}}>
                        <div className="px-4 py-3 d-flex justify-content-between align-items-center" id="headingOne">
                          
                        <Link to={"/allPatient"}>

                        <div className="myProfileCard"> 

                          <span  className=" btn btn-theme-bg " ><UserIcon /></span>
                            <h6 className="mb-0 ml-2 dark-text font-weight-bold" data-toggle="collapse" data-target="#collapsethree" aria-expanded="true" aria-controls="collapsethree">
                            My Patient                            </h6>
                            </div>

                            </Link>
                                <Lefticon />
                        </div>

                        <div id="collapsethree" className="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                            <div className="card-body">
                                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
                            </div>
                        </div>
                    </div>

                  
                    <div className="card  w-75 mx-auto shadow-lg mt-2" style={{border:"none",borderRadius:"17px"}}>
                        <div className="px-4 py-3 d-flex justify-content-between align-items-center" id="headingOne">
                            <Link to={"/history"}>
                            <div className="myProfileCard">
                                <span className="btn btn-theme-bg "> <Time /></span>
                            <h6 className="mb-0 ml-2 font-weight-bold dark-text" data-toggle="collapse" data-target="#collapsefive" aria-expanded="true" aria-controls="collapsefive">
                            History
                            </h6>
                            </div>                   
                                                  </Link>   
                                <Lefticon />
                        </div>

                        <div id="collapsefive" className="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                            <div className="card-body">
                                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
                            </div>
                        </div>
                    </div>
                    <div className="card  w-75 mx-auto shadow-lg mt-2" style={{border:"none",borderRadius:"17px"}}>
                        <div className="px-4 py-3 d-flex justify-content-between align-items-center" id="headingOne">
                            <Link to={"/settings"} >
                        <div className="myProfileCard">
                                <span className="btn btn-theme-bg "> <Settings /></span>
                            <h6 className="mb-0 ml-2 font-weight-bold dark-text" data-toggle="collapse" data-target="#collapsefive" aria-expanded="true" aria-controls="collapsefive">
                            Settings
                            </h6>
                            </div>
                            </Link>
                                <Lefticon />
                        </div>

                        <div id="collapsefive" className="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                            <div className="card-body">
                                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
                            </div>
                        </div>
                    </div>
             
                </div>



            </div>
        </Layout>
        </>
    )
}

export default MyProfile;